import React from 'react'
import './CSS/Categories.css'
const Categories = () => {
  return (
    <div>
      Categories
    </div>
  )
}

export default Categories
